import React from 'react';
import styled from 'styled-components';
const Item = styled.div `
  min-width: 0;
  flex-grow: ${(props) => props.flexGrow || 0};
  flex-shrink: ${(props) => props.flexShrink || '1'};
  flex-basis: ${(props) => props.flexBasis || 'auto'};
  order: ${(props) => props.order || 0};
  align-self: ${(props) => props.alignSelf || 'auto'};
  ${(props) => props.flex && `flex: ${props.flex};`}
  ${(props) => props._isVisible && 'background-color: yellow;'}
  ${(props) => props.transition && `transition: ${props.transition};`}
`;
/**
 * A flexible item component to be used within a ImpFlex container.
 *
 * @param {React.ReactNode} props.children - The content of the flex item.
 * @param {number} [props.flexGrow=0] - The factor by which the flex item will grow in relation to other items in the container when there is extra space.
 * @param {number} [props.flexShrink=1] - The factor by which the flex item will shrink in relation to other items in the container when there isn't enough space.
 * @param {string | number} [props.flexBasis='auto'] - The initial main size of the flex item, before free space is distributed according to the flex factors.
 * @param {number} [props.order=0] - The order in which the flex item appears within the flex container.
 * @param {string} [props.alignSelf='auto'] - The alignment of the flex item along the cross axis. Overrules align-items on the flex container.
 * @param {string} [props.dataTestId='flex-item'] - The data-testid of the flex item.
 * @param {string} [props.flex] - The flex shorthand property sets how a flex item will grow or shrink to fit the space available in its flex container.
 * @returns The ImpFlexItem component.
 */
export default function ImpFlexItem({ children, flexGrow = 0, flexShrink = 1, flexBasis = 'auto', order = 0, alignSelf = 'auto', dataTestId = 'flex-item', flex, transition, _isVisible = false, }) {
    return (React.createElement(Item, { flexGrow: flexGrow, flexShrink: flexShrink, flexBasis: flexBasis, order: order, alignSelf: alignSelf, "data-testid": dataTestId, flex: flex, transition: transition, _isVisible: _isVisible }, children));
}
//# sourceMappingURL=ImpFlexItem.js.map